import { isEmpty } from 'lodash-es'

export function numberThousandSeparator(data) {
  const num = Number(data)
  if (data === null || data === undefined || isNaN(num)) return '0'

  return num.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })
}

export function budgetFormat(data) {
  let _data
  if (typeof data === 'string' && !isEmpty(data)) {
    _data = parseFloat(data.replace(/,/g, ''))
  } else {
    _data = data
  }

  if (isNaN(_data)) {
    _data = 0
  }

  return _data?.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
